'use client';

import { useRatingReviews } from '@/hooks/useRatingReviews';
import { GoogleReviewServer } from './server';

export default function GoogleReviewsClient({ placeId }: { placeId?: string }) {
  const result = useRatingReviews(placeId);
  const resolvedPlaceId = placeId || (process.env.NEXT_PUBLIC_GOOGLE_PLACE_ID ?? '');

  if (result.loading) {
    return <GoogleReviewServer href="#" rating={0} />;
  }

  if (!result.rating) {
    return null;
  }

  return (
    <GoogleReviewServer
      href={`https://search.google.com/local/reviews?placeid=${resolvedPlaceId}`}
      rating={result.rating}
    />
  );
}
